import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-8 pt-24 pb-4">
      <ol className="flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-700 cursor-pointer flex items-center gap-1">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-base" />
            </span>
            首页
          </Link>
        </li>
        {items.map((c) => (
          <li key={c.label} className="flex items-center gap-1.5">
            <span className="w-4 h-4 flex items-center justify-center text-foreground-300">
              <i className="ri-arrow-right-s-line text-base" />
            </span>
            {c.to ? (
              <Link to={c.to} className="hover:text-primary-700 cursor-pointer">
                {c.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}